var _path, _path2, _g, _path3, _path4, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEmptyAnalytic = function SvgEmptyAnalytic(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "url(#paint0_linear_571_135443)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_571_135443",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 151,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "url(#paint1_linear_571_135443)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_571_135443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.066 59H32.9332C31.7576 59.0007 30.6305 59.469 29.7993 60.302C28.968 61.135 28.5007 62.2645 28.5 63.4426V143.557C28.5007 144.735 28.968 145.865 29.7993 146.698C30.6305 147.531 31.7576 147.999 32.9332 148H120.066C121.242 147.999 122.369 147.531 123.201 146.698C124.032 145.865 124.499 144.736 124.5 143.557V63.4426C124.499 62.2645 124.032 61.1348 123.201 60.3018C122.369 59.4688 121.242 59.0006 120.066 59Z",
    fill: "url(#paint2_linear_571_135443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.071 17H43.9286C40.9305 17 38.5 20.07 38.5 23.8571V106.143C38.5 109.93 40.9305 113 43.9286 113H109.071C112.07 113 114.5 109.93 114.5 106.143V23.8571C114.5 20.07 112.07 17 109.071 17Z",
    fill: "url(#paint3_linear_571_135443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.455 100.425L124.314 144.186C124.007 146.374 122.146 148 119.951 148H32.2062C30.0113 148 28.1511 146.374 27.844 144.186L19.5441 85.0546C19.1697 82.3851 21.2277 80 23.9063 80H51.0038C53.1988 80 55.059 81.6259 55.366 83.8133L56.4537 91.557C56.7608 93.7448 58.621 95.3707 60.8159 95.3707H126.094C128.772 95.3707 130.83 97.7559 130.456 100.425H130.455Z",
    fill: "url(#paint4_linear_571_135443)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.176 129H42.8239C42.4603 129 42.1091 128.875 41.8363 128.649C41.5634 128.422 41.3876 128.11 41.3418 127.77L40.5116 121.582C40.4852 121.384 40.5039 121.183 40.5663 120.993C40.6287 120.802 40.7335 120.626 40.8736 120.476C41.0138 120.327 41.1862 120.207 41.3793 120.125C41.5724 120.043 41.7819 120 41.9938 120H110.006C110.218 120 110.428 120.043 110.621 120.125C110.814 120.207 110.986 120.327 111.126 120.476C111.267 120.626 111.371 120.802 111.434 120.993C111.496 121.183 111.515 121.384 111.488 121.582L110.658 127.77C110.612 128.11 110.437 128.422 110.164 128.649C109.891 128.875 109.54 129 109.176 129Z",
    fill: "#C2EDFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_571_135443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5571 46.3145H123.843C124.563 46.3145 125.253 46.6004 125.762 47.1094C126.271 47.6185 126.557 48.3089 126.557 49.0287V62.6002C126.557 63.32 126.271 64.0104 125.762 64.5195C125.253 65.0285 124.563 65.3145 123.843 65.3145H50.5571C49.8372 65.3145 49.1468 65.0285 48.6378 64.5195C48.1287 64.0104 47.8428 63.32 47.8428 62.6002V49.0287C47.8428 48.3089 48.1287 47.6185 48.6378 47.1094C49.1468 46.6004 49.8372 46.3145 50.5571 46.3145V46.3145Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.7282 50.6572H76.6139C75.7145 50.6572 74.9854 51.3864 74.9854 52.2858C74.9854 53.1852 75.7145 53.9144 76.6139 53.9144H90.7282C91.6276 53.9144 92.3568 53.1852 92.3568 52.2858C92.3568 51.3864 91.6276 50.6572 90.7282 50.6572Z",
    fill: "#B3EAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 57.7139H76.6139C75.7145 57.7139 74.9854 58.443 74.9854 59.3424C74.9854 60.2419 75.7145 60.971 76.6139 60.971H100.5C101.399 60.971 102.128 60.2419 102.128 59.3424C102.128 58.443 101.399 57.7139 100.5 57.7139Z",
    fill: "#DBF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3998 60.9705C67.248 60.9705 69.557 58.6616 69.557 55.8134C69.557 52.9652 67.248 50.6562 64.3998 50.6562C61.5516 50.6562 59.2427 52.9652 59.2427 55.8134C59.2427 58.6616 61.5516 60.9705 64.3998 60.9705Z",
    fill: "#64D5D2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_571_135443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2143 69.6562H100.5C101.22 69.6562 101.91 69.9422 102.419 70.4512C102.928 70.9603 103.214 71.6507 103.214 72.3705V85.942C103.214 86.6618 102.928 87.3522 102.419 87.8613C101.91 88.3703 101.22 88.6562 100.5 88.6562H27.2143C26.4944 88.6562 25.804 88.3703 25.295 87.8613C24.786 87.3522 24.5 86.6618 24.5 85.942V72.3705C24.5 71.6507 24.786 70.9603 25.295 70.4512C25.804 69.9422 26.4944 69.6562 27.2143 69.6562V69.6562Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.3857 74H53.2714C52.372 74 51.6428 74.7291 51.6428 75.6286C51.6428 76.528 52.372 77.2571 53.2714 77.2571H67.3857C68.2851 77.2571 69.0143 76.528 69.0143 75.6286C69.0143 74.7291 68.2851 74 67.3857 74Z",
    fill: "#B3EAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1571 81.0576H53.2714C52.372 81.0576 51.6428 81.7868 51.6428 82.6862C51.6428 83.5856 52.372 84.3148 53.2714 84.3148H77.1571C78.0565 84.3148 78.7857 83.5856 78.7857 82.6862C78.7857 81.7868 78.0565 81.0576 77.1571 81.0576Z",
    fill: "#DBF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 84.3143C36.8481 84.3143 39.1571 82.0054 39.1571 79.1571C39.1571 76.3089 36.8481 74 33.9999 74C31.1517 74 28.8428 76.3089 28.8428 79.1571C28.8428 82.0054 31.1517 84.3143 33.9999 84.3143Z",
    fill: "#64D5D2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_571_135443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.5 22.9707H27.2143C25.7152 22.9707 24.5 24.1859 24.5 25.685V39.2564C24.5 40.7555 25.7152 41.9707 27.2143 41.9707H100.5C101.999 41.9707 103.214 40.7555 103.214 39.2564V25.685C103.214 24.1859 101.999 22.9707 100.5 22.9707Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.3 27.3135H52.1857C51.2863 27.3135 50.5571 28.0426 50.5571 28.942C50.5571 29.8415 51.2863 30.5706 52.1857 30.5706H66.3C67.1994 30.5706 67.9286 29.8415 67.9286 28.942C67.9286 28.0426 67.1994 27.3135 66.3 27.3135Z",
    fill: "#B3EAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0714 34.3701H52.1857C51.2863 34.3701 50.5571 35.0993 50.5571 35.9987C50.5571 36.8981 51.2863 37.6273 52.1857 37.6273H76.0714C76.9708 37.6273 77.7 36.8981 77.7 35.9987C77.7 35.0993 76.9708 34.3701 76.0714 34.3701Z",
    fill: "#DBF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.057 37.6278C43.9053 37.6278 46.2142 35.3188 46.2142 32.4706C46.2142 29.6224 43.9053 27.3135 41.057 27.3135C38.2088 27.3135 35.8999 29.6224 35.8999 32.4706C35.8999 35.3188 38.2088 37.6278 41.057 37.6278Z",
    fill: "#64D5D2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.604 88.1924C98.0754 88.1924 101.7 84.5676 101.7 80.0962C101.7 75.6248 98.0754 72 93.604 72C89.1326 72 85.5078 75.6248 85.5078 80.0962C85.5078 84.5676 89.1326 88.1924 93.604 88.1924Z",
    fill: "#DFEAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9303 114.7C98.6349 114.7 97.4254 114.7 96.3243 114.63C94.968 114.539 93.6633 114.075 92.5537 113.289C91.4441 112.504 90.5726 111.428 90.0351 110.179L83.2036 96.678C82.7025 96.0946 82.4523 95.3368 82.5075 94.5697C82.5627 93.8027 82.9188 93.0885 83.4983 92.5829C83.973 92.2014 84.5652 91.996 85.1742 92.0016C85.6226 92.0146 86.0628 92.1248 86.4645 92.3244C86.8662 92.5239 87.2198 92.8083 87.501 93.1577L90.6035 97.3921L90.6504 97.4471V81.36C90.6504 80.5618 90.9675 79.7964 91.5319 79.232C92.0962 78.6676 92.8617 78.3506 93.6598 78.3506C94.4579 78.3506 95.2234 78.6676 95.7878 79.232C96.3521 79.7964 96.6692 80.5618 96.6692 81.36V91.885C96.6342 91.4977 96.6803 91.1074 96.8046 90.7389C96.9288 90.3704 97.1284 90.0318 97.3908 89.7448C97.6531 89.4577 97.9724 89.2284 98.3282 89.0716C98.684 88.9147 99.0686 88.8337 99.4575 88.8337C99.8464 88.8337 100.231 88.9147 100.587 89.0716C100.943 89.2284 101.262 89.4577 101.524 89.7448C101.787 90.0318 101.986 90.3704 102.11 90.7389C102.235 91.1074 102.281 91.4977 102.246 91.885V94.0791C102.211 93.6918 102.257 93.3014 102.381 92.933C102.505 92.5645 102.705 92.2259 102.967 91.9388C103.23 91.6518 103.549 91.4225 103.905 91.2656C104.261 91.1088 104.645 91.0277 105.034 91.0277C105.423 91.0277 105.808 91.1088 106.163 91.2656C106.519 91.4225 106.839 91.6518 107.101 91.9388C107.363 92.2259 107.563 92.5645 107.687 92.933C107.811 93.3014 107.857 93.6918 107.822 94.0791V95.7696C107.788 95.3823 107.834 94.9919 107.958 94.6234C108.082 94.2549 108.282 93.9164 108.544 93.6293C108.806 93.3422 109.126 93.113 109.482 92.9561C109.837 92.7992 110.222 92.7182 110.611 92.7182C111 92.7182 111.384 92.7992 111.74 92.9561C112.096 93.113 112.415 93.3422 112.678 93.6293C112.94 93.9164 113.14 94.2549 113.264 94.6234C113.388 94.9919 113.434 95.3823 113.399 95.7696V106.031C113.344 109.187 111.918 114.507 106.9 114.507C106.535 114.524 103.449 114.702 99.9368 114.702L99.9303 114.7Z",
    fill: "#4C6978",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_571_135443",
    x: 41.8428,
    y: 43.3145,
    width: 90.7144,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_571_135443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_571_135443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_571_135443",
    x: 18.5,
    y: 66.6562,
    width: 90.7144,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_571_135443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_571_135443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_571_135443",
    x: 18.5,
    y: 19.9707,
    width: 90.7144,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_571_135443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_571_135443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_135443",
    x1: 75.5,
    y1: 0,
    x2: 75.5,
    y2: 191.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6CFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_571_135443",
    x1: 75.5,
    y1: 0,
    x2: 75.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CBD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_571_135443",
    x1: 76.5,
    y1: 59,
    x2: 76.7548,
    y2: 119.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_571_135443",
    x1: 76.5,
    y1: -20.5,
    x2: 76.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_571_135443",
    x1: 24.0492,
    y1: 118.135,
    x2: 130.5,
    y2: 118.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193638,
    stopColor: "#BED6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#C4DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72836,
    stopColor: "#BED6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#ABCAD8"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyAnalytic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-analytic.9f7b37d2.svg";
export { ForwardRef as ReactComponent };